<template>
  <div class="Warp">
	<div class="main">
	  <div class="main-div">
	    <!--内容 start-->
	    <div>
	      <van-tabs
	        class="van_tabs"
	        color="rgb(0,170,238)"
	        title-active-color="black"
	        @click="onClick(active)"
	        id="vat_tabs"
	        v-model="active"
	      >
	        <van-tab title="日报表">
	          <van-grid :column-num="5" :border="false" id="vat_grid">
	            <van-grid-item text="支付金额" />
	            <van-grid-item  text="支付订单数" />
	            <van-grid-item text="退款金额" />
	            <van-grid-item text="退款订单数" />
				<van-grid-item text="时间" />
	          </van-grid>
	        </van-tab>
	        <van-tab title="周报表">
	          <van-grid :column-num="5" :border="false" id="vat_grid">
	            <van-grid-item text="支付金额" />
	            <van-grid-item  text="支付订单数" />
	            <van-grid-item text="退款金额" />
	            <van-grid-item text="退款订单数" />
	            <van-grid-item text="时间" />
	          </van-grid>
	        </van-tab>
	        <van-tab title="月报表">
	          <van-grid :column-num="5" :border="false" id="vat_grid">
	            <van-grid-item text="支付金额" />
	            <van-grid-item  text="支付订单数" />
	            <van-grid-item text="退款金额" />
	            <van-grid-item text="退款订单数" />
	            <van-grid-item text="时间" />
	          </van-grid>
	        </van-tab>
	      </van-tabs>
	    </div>
	  </div>
	</div>
	<!--内容 end-->
	<div class="content">
	  <van-list
	    v-model="loading"
	    :finished="finished"
	    finished-text="没有更多了"
	    @load="onLoad"
	    :offset="10"
	  >
	    <div v-for="(item, index) in OrderList" :key="index">
	      <van-grid :column-num="5" :border="false">
	        <van-grid-item :text="'￥'+item.money"> </van-grid-item>
	        <van-grid-item :text="item.count"> </van-grid-item>
	        <van-grid-item :text="'￥'+item.redund_money"> </van-grid-item>
	        <van-grid-item :text="item.redund_count"> </van-grid-item>
	        <van-grid-item :text="item.date	"> </van-grid-item>
	      </van-grid>
	    </div>
	  </van-list>
	</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
	  summary_type:'day',
      OrderList: [],
      loading: false,
      refreshLoading: false,
      finished: false,
	  active: 0,
    };
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
	  //点击报表类型
	  onClick(active) {
		// 每次点击都重新加载
		this.loading = true;
		this.finished = false;
		if (active == "0") {
		  this.summary_type = "day";
		  this.page = 0;
		  this.OrderList = [];
		  this.onLoad();
		  console.log(this.summary_type);
		} else if (active == "1") {
		  this.summary_type = "week";
		  this.page = 0;
		  this.OrderList = [];
		  this.onLoad();
		  console.log(this.summary_type);
		} else if (active == "2") {
		  this.summary_type = "month";
		  this.page = 0;
		  this.OrderList = [];
		  this.onLoad();
		  console.log(this.summary_type);
		}
	  },
	// 触发下拉刷新更多
	onLoad() {
	  this.page += 1;
	  this.getOrderList();
	},
	  
    getOrderList() {
      var reqData = {
		summary_type:this.summary_type,
        pageNum: this.page,
        pageSize: this.limit,
      };
      this.$http
        .post("/wechat/api.order/consumerOrderStatistics",reqData)
        .then((res1) => {
          var res = res1.body;
          res.rows.map((v) => {
            this.OrderList.push(v);
            this.loading = false;
            this.refreshLoading = false;
            if (this.OrderList.length >= res.total) {
              this.finished = true;
            }
          });
        });
    },
    onRefresh() {
      this.page = 1;
      this.OrderList = [];
      this.finished = false;
      this.getOrderList();
    },
    uploader() {
      this.page++;
      this.getOrderList();
    },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
</style>